import { createSlice } from '@reduxjs/toolkit';
import { downloadSkuFabricMapping, updateSkuFabricMapping } from '../../apis';

import { createSkuFabricMaterial, deleteSkuMaterial, generateFabricLabels, getFabricMaterial, getFabricMaterialConfig, getFabricVendors, updateSkuFabricMaterial } from './api';

export const FabricManagementSlice = createSlice({

    name: 'FabricManagementPlatform',
    initialState: {
        isLoading: false,
        fabricData : [],
        fabricVendors: [],
        fabricConfigData: {},
        error: '',
        createSkuFabricMaterialSuccess: false,
        generateFabricLabelsSuccess: false,
        updateSkuFabricMaterialSuccess: false,
        deleteSkuFabricMaterialSuccess: false,
        updateSkuFabricMappingSuccess: false,
        downloadSkuFabricMappingSuccess: false
    },

    reducers: {
      clear: (state, action) => {
        return {
          ...state,
          [action.payload.key]: action.payload.value
        }
      }
    },

    extraReducers: (builder) => {
        builder.addCase(getFabricMaterial.pending, (state, action) => {
            state.isLoading = true;
            state.fabricData = []
        })
        builder.addCase(getFabricMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.fabricData = action.payload.data;
        })
        builder.addCase(getFabricMaterial.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(createSkuFabricMaterial.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(createSkuFabricMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.createSkuFabricMaterialSuccess = action.payload.data?.message?.length ? action.payload.data?.message : true;
        })
        builder.addCase(createSkuFabricMaterial.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(generateFabricLabels.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(generateFabricLabels.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.generateFabricLabelsSuccess = true;
        })
        builder.addCase(generateFabricLabels.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(updateSkuFabricMaterial.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(updateSkuFabricMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.updateSkuFabricMaterialSuccess = true;
        })
        builder.addCase(updateSkuFabricMaterial.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(getFabricMaterialConfig.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getFabricMaterialConfig.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.fabricConfigData = action.payload.data;
        })
        builder.addCase(getFabricMaterialConfig.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(getFabricVendors.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getFabricVendors.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.fabricVendors = action.payload.data;
        })
        builder.addCase(getFabricVendors.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(deleteSkuMaterial.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(deleteSkuMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.deleteSkuFabricMaterialSuccess = action.payload.message ?? true;
        })
        builder.addCase(deleteSkuMaterial.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(updateSkuFabricMapping.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(updateSkuFabricMapping.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.updateSkuFabricMappingSuccess = action.payload?.message ?? true;
        })
        builder.addCase(updateSkuFabricMapping.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(downloadSkuFabricMapping.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(downloadSkuFabricMapping.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.downloadSkuFabricMappingSuccess = action.payload?.message ?? true;
        })
        builder.addCase(downloadSkuFabricMapping.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        
    }
})

export const { clear } = FabricManagementSlice.actions


export default FabricManagementSlice.reducer